import { useLayoutEffect } from 'react';

/* Ширину колонки контента объявляет сам режим, а не оболочка.

   Оболочка (.main-content в global.css) читает CSS-переменные с :root. Пока их
   никто не объявил, действуют значения по умолчанию — те же 1100px, что были
   при фиксированной ширине. Переменные снимаются при уходе со страницы, поэтому
   режимы ничего не знают друг о друге и порядок переходов не важен.

   Использование: usePageWidth('pageWide') первой строкой в теле компонента режима.
   Компонент страницы-карточки объявляет ширину сам — так же, как компонент
   перечня: маршрут /<режим>/:id рендерит другой компонент.

   Резиновые наборы (fluid — `pageWide` и `extraWide`) вдобавок ставят на <html>
   класс `shell-fluid`. Он снимает с оболочки нижние границы ширины: 1100px у
   .main-content, 1104px у .header__content и 1024px у .header/.footer ниже
   1029px — из-за них на узком окне вся страница уезжала в горизонтальную
   прокрутку. Прежние режимы класса не получают и ведут себя как раньше.
   Сами правила — в global.css, раздел «Резиновая оболочка режимов нового
   канона». */

const FLUID_SHELL_CLASS = 'shell-fluid';

export const PAGE_WIDTH_PRESETS = {
    // широкие таблицы: по краям окна остаются поля (напр. Тематические планы)
    wide: { width: '96vw', maxWidth: '1400px' },
    // режимы по новым макетам, поля по краям окна (напр. КТП потоков)
    extraWide: { width: '96vw', maxWidth: '1900px', fluid: true },
    // колонка ровно как в макетах: боковые поля даёт сам режим (padding у .page),
    // на 1920 колонка = 1900, содержимое = 1820; сжимается вплоть до 800×600
    pageWide: { width: '100%', maxWidth: '1900px', fluid: true },
};

/* То же самое вне хука — для классовых компонентов (карточка дисциплины).
   Возвращает функцию отмены; её вызывают в componentWillUnmount. */
export const applyPageWidth = preset => {
    const size = PAGE_WIDTH_PRESETS[preset];
    if (!size) return () => {};

    const root = document.documentElement;
    const { style } = root;
    style.setProperty('--content-width', size.width);
    style.setProperty('--content-max-width', size.maxWidth);
    if (size.fluid) root.classList.add(FLUID_SHELL_CLASS);

    return () => {
        style.removeProperty('--content-width');
        style.removeProperty('--content-max-width');
        root.classList.remove(FLUID_SHELL_CLASS);
    };
};

const usePageWidth = preset => {
    useLayoutEffect(() => applyPageWidth(preset), [preset]);
};

export default usePageWidth;
